import React from "react";

const Success = (props) => {

    const {
        isCustomer,
        isFetching,
        executor,
        itsMyBid,
        evaluateWork,
        openShareModal,
        downloadWork,
        currentOrder,
    } = props;

    let photos = executor.photos && executor.photos.results || [];
    let videos = executor.videos && executor.videos.results || [];

    let setWorks = [...photos, ...videos];
    const issetPhotos = setWorks.length ? true : false;

    return (
        <div className="work-accept-success">
            <strong className="success-caption">
                {
                    isCustomer
                    ? 'Вы приняли работу!'
                    : itsMyBid
                    ? 'Ваша работа принята!'
                    : 'Работа принята!'
                }
            </strong>

            {
                isCustomer && issetPhotos ?
                <div>
                    {
                        [<div key="1" style={{marginBottom: '12px'}}>
                            <a href=""
                                className={isFetching ? 'disabled' : ''}
                                onClick={(e) => {e.preventDefault(); downloadWork()}}
                                >Скачать результат в оригинале</a>
                        </div>,
                        <div key="2" style={{marginBottom: '12px'}}>
                            <a href=""
                                onClick={(e) => {e.preventDefault(); openShareModal(executor)}}
                                >Опубликовать на сайте</a>
                        </div>]
                    }
                    
                    {
                        !currentOrder.is_failed && executor.status === 4 ?
                        <div className="button-action big-button estimate-work">
                            <button onClick={() => evaluateWork(executor.id)}>Оценить работу</button>
                        </div>
                        : null
                    }
                </div>
                : null
            }
            
        </div>
    );
}

export default Success;


// WEBPACK FOOTER //
// ./src/components/MakeOrder/Success.js